import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054366a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center q-mb-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, _mergeProps({ "form-width": _ctx.dialogWidth }, _ctx.$props, {
    onCancel: _ctx.cancel,
    onConfirm: _ctx.confirm,
    onSecondary: _ctx.secondary,
    ref: "dialog"
  }), {
    content: _withCtx(() => [
      (_ctx.message)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "bg-white q-pt-sm"
          }, {
            default: _withCtx(() => [
              (_ctx.iconName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_q_icon, _mergeProps({ name: _ctx.iconName }, { ..._ctx.iconProps, size: _ctx.iconSize }), null, 16, ["name"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.message)
                ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 1 }, _ctx.TEXT_CONTENT_BODY, { class: "handle-break-line text-align-center" }), _toDisplayString(_ctx.message), 17))
                : _createCommentVNode("", true),
              (_ctx.subMessage)
                ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 2 }, _ctx.TEXT_CONTENT_BODY, { class: "handle-break-line text-align-center" }), _toDisplayString(_ctx.subMessage), 17))
                : _createCommentVNode("", true),
              (_ctx.deleteMessage)
                ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 3 }, _ctx.TEXT_CONTENT_BODY, { class: "handle-break-line text-align-center q-mt-md" }), _toDisplayString(_ctx.deleteMessage), 17))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    after: _withCtx(() => [
      _createVNode(_component_q_card_actions, { class: "q-px-lg q-py-sm q-pt-none" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, _mergeProps({
            label: _ctx.t('ACTION.CANCEL')
          }, _ctx.secondaryLabel?.length > 0 ? _ctx.BTN_TERTIARY_LG : _ctx.BTN_SECONDARY_LG), null, 16, ["label"]), [
            [_directive_close_popup]
          ]),
          (_ctx.secondaryLabel?.length > 0)
            ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                key: 0,
                label: _ctx.secondaryLabel
              }, _ctx.negativeStyle ? _ctx.BTN_SECONDARY_LG : _ctx.BTN_NEGATIVE_SECONDARY_LG, { onClickOnce: _ctx.secondary }), null, 16, ["label", "onClickOnce"]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_space),
          _createVNode(_component_q_btn, _mergeProps({
            label: _ctx.confirmLabel ?? _ctx.t('ACTION.CONFIRM'),
            onClickOnce: _ctx.confirm,
            disable: _ctx.loading
          }, _ctx.negativeStyle ? _ctx.BTN_NEGATIVE_LG : _ctx.BTN_PRIMARY_LG), null, 16, ["label", "onClickOnce", "disable"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["form-width", "onCancel", "onConfirm", "onSecondary"]))
}